import React from 'react'

import { Box } from 'components/layout/Box/Box'
import { Description } from 'components/modals/TestsReportModal/common/Description/Description'
import { Accordion } from 'components/shared/Accordion/Accordion'
import { ScoreChip } from 'components/shared/ScoreChip/ScoreChip'

import { getTraitTranslation } from 'components/modals/TestsReportModal/tabs/helpers'
import { getFactorScoreTreshholds } from 'utils/score'
import { percentScore } from 'utils/stringFormat'
import cx from 'classnames'
import styles from './Trait.module.scss'

export const Trait = ({
  trait,
  scores,
  language,
  onToggle,
  isInitiallyOpen,
  wrap,
}) => {
  const score = scores?.[trait]

  const {
    label,
    abstract = [],
    description = [],
  } = getTraitTranslation(trait, score, language)

  return (
    <Accordion
      className={cx(styles.trait, {
        [styles.wrap]: wrap,
      })}
      {...{ isInitiallyOpen }}
    >
      <Accordion.Header
        className={styles.header}
        title={
          <Box
            align="center"
            className={styles.title}
            justify="space-between"
            tagName="span"
          >
            <span className={styles.label}>{label}</span>
            <ScoreChip
              score={percentScore(score)}
              size="small"
              theme={getFactorScoreTreshholds(score)}
            />
          </Box>
        }
        onToggle={() => onToggle(trait)}
      />
      <Accordion.Panel>
        <Box className={styles.panel} direction="column">
          <Description text={abstract} />
          <Description text={description} />
        </Box>
      </Accordion.Panel>
    </Accordion>
  )
}
